/**
 * Loads product recommendations once the section scrolls near the viewport and swaps in the
 * rendered section markup. Keeps the section empty (and hidden by CSS) when nothing comes back.
 */
class EbRecommendations extends HTMLElement {
  #observer = /** @type {IntersectionObserver | undefined} */ (undefined);
  #abort = new AbortController();

  connectedCallback() {
    if (this.querySelector('.eb-product-row__grid')) return;
    this.#observer = new IntersectionObserver(
      (entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        this.#observer?.disconnect();
        this.#load();
      },
      { rootMargin: '0px 0px 400px 0px' }
    );
    this.#observer.observe(this);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
    this.#abort.abort();
  }

  async #load() {
    const url = this.dataset.url;
    if (!url) return;
    try {
      const response = await fetch(url, { signal: this.#abort.signal });
      if (!response.ok) return;
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('eb-recommendations');
      if (fresh && fresh.innerHTML.trim()) this.innerHTML = fresh.innerHTML;
    } catch (error) {
      if (error instanceof DOMException && error.name === 'AbortError') return;
      // Recommendations are optional; leave the section empty on failure.
    }
  }
}

if (!customElements.get('eb-recommendations')) customElements.define('eb-recommendations', EbRecommendations);
